import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/round creams/round lorio biscuit.png";
import BiscuitImg from "../../../assets/products/round creams/Round-Lorio.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 18,
  },
  {
    grams: 50,
  },
  {
    grams: 100,
  },
  {
    grams: 500,
  },
];

export default function LoreoRoundProduct() {
  return (
    <>
      <Helmet>
        <title>
          Round Loreo Cream Biscuit – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz Round Loreo Cream Biscuits — rich crème-filled round biscuits with premium flavor. View pack sizes, cartons, and specs."
        />
        <meta
          name="keywords"
          content="Round Loreo Cream Biscuit, BearBitz Loreo Cream Biscuit"
        />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/round-cream-biscuit/round-loreo"
        />
        <meta
          property="og:title"
          content="Round Loreo Cream Biscuit – BearBitz"
        />
        <meta
          property="og:description"
          content="Cream-filled Loreo-style round biscuit with export-ready packaging and flavor."
        />
      </Helmet>

      <ProductTemplate
        productTitle="LOREO"
        productImage={BisImg}
        description="Loreo Cookies are delightfully crunchy chocolate cookies filled with rich, creamy vanilla crème. Perfect for snacking, sharing, or dipping in milk."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#6EB9FF"
        sectionBgColor="#E3F1FF"
        productBgcolor="#6EB9FF"
        tableheadBgcolor="#6EB9FF"
        tableBgcolor="#ffffff"
        footerBgcolor="#6EB9FF"
      />
    </>
  );
}
